import React, { memo } from 'react';
import { Handle, Position, useReactFlow } from 'reactflow';
import CustomResizer from './CustomResizer';
import { ApiOutlined } from '@ant-design/icons';
import NodeLabel from './NodeLabel';
import { useNodeTitle } from './useNodeTitle';

const CodeNode = ({ id, data, selected }) => {
    const onTitleChange = useNodeTitle(id, data);

    return (
        <div style={{
            background: 'transparent',
            padding: 20,
            height: '100%',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative'
        }}>
            <CustomResizer
                isVisible={selected}
                minWidth={200}
                minHeight={100}
                onResizeEnd={(event, params) => {
                    const { width, height, x, y } = params;
                    if (data.onResize) {
                        data.onResize(id, { width, height, x, y });
                    }
                }}
            />
            <NodeLabel
                title={data.nodeTitle || 'Code'}
                iconType={data.iconType || 'api'}
                color={data.nodeColor || '#fadb14'}
                onTitleChange={onTitleChange}
            />
            <Handle type="target" position={Position.Left} style={{
                width: 150, height: 150, left: -180, top: 120,
                borderRadius: '50%',
                border: '12px solid #0d1117', background: '#555',
                boxShadow: '0 12px 36px rgba(0,0,0,0.5)'
            }} />

            <div style={{
                background: '#1e1e1e',
                color: '#d4d4d4',
                borderRadius: 6,
                border: '1px solid #30363d',
                boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
                fontFamily: 'Consolas, "Courier New", monospace',
                fontSize: 12,
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                overflow: 'hidden'
            }}>
                <div style={{ background: '#252526', padding: '4px 8px', borderTopLeftRadius: 6, borderTopRightRadius: 6, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
                    <span style={{ fontWeight: 'bold', color: '#9cdcfe' }}>{data.filename || 'script.js'}</span>
                    <div style={{ display: 'flex', gap: 4 }}>
                        <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#ff5f56' }}></div>
                        <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#ffbd2e' }}></div>
                        <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#27c93f' }}></div>
                    </div>
                </div>

                <div style={{ padding: 12, whiteSpace: 'pre-wrap', flex: 1, overflow: 'auto' }}>
                    {data.code || `const greeting = "Hello World";\nconsole.log(greeting);`}
                </div>
            </div>

            <Handle type="source" position={Position.Right} style={{
                width: 150, height: 150, right: -180, top: 120,
                borderRadius: '50%',
                background: data.nodeColor || '#fadb14', border: '12px solid #0d1117',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                boxShadow: '0 12px 36px rgba(0,0,0,0.5)'
            }}>
                <ApiOutlined style={{ color: '#fff', fontSize: 72, pointerEvents: 'none' }} />
            </Handle>
        </div>
    );
};

export default memo(CodeNode);
